// extracted by mini-css-extract-plugin
export default {"menuItem":"styles_menuItem__vFtfH","active":"styles_active__l-rGe","parentActive":"styles_parentActive__4x4PC"};